import type { MultiColumnsGap } from 'blocks/MultiColumns'
import type { IDescriptionProps } from './Description'

import { styled } from '@linaria/react'
import { BorderOuterSC } from 'atoms/BorderOuter'
import { IconSC, IconSizes } from 'atoms/Icon'
import { LABEL_PADDINGS, LabelStyled } from 'atoms/Label'
import { TextBoxSC } from 'atoms/TextBox'
import { TimerSC, TimerWrapper } from 'atoms/Timer'
import { ButtonGroupWrapper } from 'blocks/ButtonGroup'
import { ListStyled } from 'blocks/List'
import { MultiColumnsItemStyled } from 'blocks/MultiColumns'
import { FIXED_INDENTS, MEDIA } from 'vars/index'
import {
  DescriptionAlignItems,
  DescriptionColumnGap,
  DescriptionDirection,
  DescriptionJustifyContent,
  DescriptionRowGap,
} from './Description.h'

export const TitleWrapper = styled.div``

export const DescriptionStyled = styled.div<IDescriptionProps>`
  padding: ${({ paddings }) => (paddings?.length ? `var(${paddings}) ` : 0)};
  overflow: hidden;

  & ${TitleWrapper} {
    display: flex;
    align-items: center;
    column-gap: var(${FIXED_INDENTS.INDENT_40});
    max-width: 100%;
  }

  ${MEDIA.MIN_1240} {
    & ${TitleWrapper} {
      max-width: 45%;
    }
  }
  display: flex;
  width: ${({ width }) => (width ? `${width}%` : 'auto')};
  max-width: 100%;
  flex-direction: ${({ direction }) =>
    direction || DescriptionDirection.Column};
  align-items: ${({ alignItems }) =>
    alignItems || DescriptionAlignItems.FlexStart};
  justify-content: ${({ justifyContent }) =>
    justifyContent || DescriptionJustifyContent.FlexStart};
  row-gap: ${({ rowGap }) => `var(${rowGap || DescriptionRowGap.INDENT_0})`};
  column-gap: ${({ columnGap }) =>
    `var(${columnGap || DescriptionColumnGap.INDENT_0})`};

  & ${ListStyled} {
    overflow: hidden;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none; // firefox
  }

  & > ${ButtonGroupWrapper} {
    box-sizing: content-box;
    padding-top: var(${FIXED_INDENTS.INDENT_40});
    max-height: var(${FIXED_INDENTS.INDENT_120});
  }
`

export const DescriptionLabelGroupSC = styled.div<{ rented?: boolean }>`
  display: flex;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_20});

  ${BorderOuterSC} {
    ${LabelStyled} {
      padding: ${({ rented }) =>
        rented
          ? `var(${LABEL_PADDINGS.SIZE_50})`
          : `var(${LABEL_PADDINGS.SIZE_40})`};
    }

    ${IconSC} {
      font-size: ${IconSizes.sSmall};
    }

    ${TextBoxSC} {
      display: block;
      white-space: nowrap;
    }
  }
`

export const LiveEventDescriptionColumnSC = styled.div<{
  rowGap?: MultiColumnsGap
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: var(--descriptionColumnWidth);

  row-gap: ${({ rowGap }) => `var(${rowGap || FIXED_INDENTS.INDENT_20})`};
  align-self: baseline;
  > ${MultiColumnsItemStyled} {
    width: 100%;
  }
  ${MEDIA.MIN_1240} {
    width: var(--descriptionColumnWidth);
  }
`

export const LiveEventDescriptionSC = styled(DescriptionStyled)`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  --descriptionColumnWidth: 100%;
  --rowGap: var(${FIXED_INDENTS.INDENT_80});
  row-gap: var(--rowGap);

  ${ButtonGroupWrapper} {
    max-height: var(${FIXED_INDENTS.INDENT_120});
  }

  > ${MultiColumnsItemStyled} {
    width: var(--descriptionColumnWidth);
  }
  ${TitleWrapper} {
    max-width: unset;
  }
  ${TimerWrapper} {
    width: 100%;
    > span:first-child {
      display: none;
    }
  }

  ${TimerSC} {
    width: var(--descriptionColumnWidth);

    > :nth-child(4) {
      display: none;
    }
  }
  ${MEDIA.MIN_600} {
    --descriptionColumnWidth: 510px;
    --rowGap: var(${FIXED_INDENTS.INDENT_140});
  }
  ${MEDIA.MIN_1240} {
    --descriptionColumnWidth: 47%;
    --rowGap: unset;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    > div:first-child {
      flex: 0 0 auto;
    }
    > div:last-child {
      flex: 1;
    }
    ${TimerSC} {
      width: 100%;
    }
    ${TimerWrapper} {
      > span:first-child {
        display: block;
      }
    }
  }

  ${MEDIA.MAX_1239_LANDSCAPE} {
    ${TimerWrapper} {
      margin-top: var(--rowGap);
    }
  }
`

export const InfoBlockDescriptionSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_10});
`
